import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources, Lang } from './locales';

const LANG_KEY = 'sata_lang';
const saved = (typeof localStorage !== 'undefined' && localStorage.getItem(LANG_KEY)) || 'uz';

i18n.use(initReactI18next).init({
  resources,
  lng: saved,
  fallbackLng: 'uz',
  interpolation: { escapeValue: false },
});

export function setLanguage(lng: Lang) {
  i18n.changeLanguage(lng);
  try {
    localStorage.setItem(LANG_KEY, lng);
  } catch {
    /* ignore */
  }
}

export default i18n;
